import * as React from 'react';

import styles from './inline-text-button.module.css';

type Props = {
    children: React.ReactNode;
    onClick: (e: React.SyntheticEvent<any>) => void;
};

export function InlineTextButton(props: Props) {
    return (
        <button type='button' onClick={props.onClick} className={styles['inline-button']}>
            {props.children}
        </button>
    );
}
